import { render, staticRenderFns } from "./knowledgeBase.vue?vue&type=template&id=ddffa77c&scoped=true"
import script from "./knowledgeBase.vue?vue&type=script&lang=js"
export * from "./knowledgeBase.vue?vue&type=script&lang=js"
import style0 from "./knowledgeBase.vue?vue&type=style&index=0&id=ddffa77c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddffa77c",
  null
  
)

export default component.exports